import { Component } from '@theme/component';
import { mediaQueryLarge, isMobileBreakpoint } from '@theme/utilities';
import { onAnimationEnd } from '@theme/utilities';

/**
 * A custom element that manages sticky sidebar.

 * @extends {Component}
 */
class StickySidebar extends Component {
  /** @type {HTMLElement | null} */
  block = null;
  /** @type {HTMLElement | null} */
  header = null;

  /** @type {EventListener | null} */
  stickyHeaderHandler = null;

  connectedCallback() {
    super.connectedCallback();
    this.block = this.closest('.shopify-block');
    this.header = document.getElementById('header-component');
    const stickyWrapper = this.refs['sticky-wrapper'];
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

    if (!this.header) return;

    this.stickyHeaderHandler = (event) => {
      const customEvent = /** @type {CustomEvent} */ (event);

      if (
        customEvent.detail.header.dataset.stickyState === 'active' &&
        (typeof customEvent.detail.header.dataset.animating === 'undefined' ||
          (isSafari && customEvent.detail.header.dataset.animating === ''))
      ) {
        if (stickyWrapper && stickyWrapper instanceof HTMLElement) {
          stickyWrapper.style.top = `${customEvent.detail.header.parentElement.offsetHeight - 1}px`;
        }
        if (this.block && this.block instanceof HTMLElement) {
          this.block.style.top = `${customEvent.detail.header.parentElement.offsetHeight - 1}px`;
        }
      } else {
        if (this.block && this.block instanceof HTMLElement) {
          this.block.style.top = '0';
        }
        if (stickyWrapper && stickyWrapper instanceof HTMLElement) {
          stickyWrapper.style.top = '0';
        }
      }
    };

    this.header.addEventListener('stickyHeader', this.stickyHeaderHandler);
  }

  close() {
    const sidebarAccordion = this.querySelector('sidebar-accordion');
    if (
      sidebarAccordion instanceof HTMLElement &&
      'details' in sidebarAccordion &&
      sidebarAccordion.details instanceof HTMLDetailsElement &&
      typeof sidebarAccordion.details.open === 'boolean'
    ) {
      sidebarAccordion.details.open = false;
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    if (this.header && this.stickyHeaderHandler) {
      this.header.removeEventListener('stickyHeader', this.stickyHeaderHandler);
    }
  }
}

if (!customElements.get('sticky-sidebar')) {
  customElements.define('sticky-sidebar', StickySidebar);
}
